window.addEventListener('load', function() {
    // Product Slider
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        adaptiveHeight: true,
        fade: true,
        infinite: true,
        asNavFor: '.slider-nav'
    });

    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        focusOnSelect: true,
        arrows: true,
        infinite: true,
        prevArrow: $('.product-prev'),
        nextArrow: $('.product-next')
    });

    $('.product-reels').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
            }
        }
        ]
    });

    $('.vs-mbl').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000
    });

    $('a.scroll-btn, .try-btn').on('click', function(e){
        e.preventDefault();
        var target = '#buy';
        var $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 900, 'swing', function () {
            // window.location.hash = target;
        });
    });

    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    var day1 = 3;
    var day2 = 7;
    var newDate = new Date(Date.now()+day1*24*60*60*1000);
    var newDate2 = new Date(Date.now()+day2*24*60*60*1000);
    $(".del-date").text(monthNames[newDate.getMonth()] + " " + newDate.getDate() + "-" + monthNames[newDate2.getMonth()] + " " + + newDate2.getDate());

    function applyDefaultSubscription() {
      const subOption = document.querySelector('input[data-name="Subscribe and Save"]');
      if (subOption) {
        $('input[data-name="Subscribe and Save"]').prop('checked', true).trigger('change').trigger('click');
        console.log('Subscribe & Save preselected');
        $('.disable').removeClass("disable");
      } else {
        console.log('Waiting for Loop widget...');
      }
    }
   // document.addEventListener('loop:widget:rendered', applyDefaultSubscription);
    window.addEventListener('load', function() {
     // setTimeout(applyDefaultSubscription, 500);
    });

   // $('.disable').removeClass("disable");

    function addItemToCart() {
        data = {
          "id": 51176278720829,
          "quantity": 1,
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() { 
            window.location.href = '/checkout'; 
          }
        });
    }

    function addItemToCartSubscription() {
      fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const existingProduct = cart.items.find(item => item.product_id == "51176278720829");
                    
                    if (existingProduct) {
                        window.location.href = '/checkout';
                        return; 
                    } else {
                        data = {
                          "id": 51176278720829,
                          "quantity": 1,
                          "selling_plan": 691207242045
                        }
                        jQuery.ajax({
                          type: 'POST',
                          url: '/cart/add.js',
                          data: data,
                          dataType: 'json',
                          success: function() { 
                            window.location.href = '/checkout'; 
                          }
                        });
                    }
                });
      }

    $('.option').on('click', function(e){
        var link = $(this).attr('data-link');
        var type = $(this).attr('data-type');
        var bprice = $(this).attr('data-atext');
        $('.option').removeClass("active");
        $(this).addClass("active");
        $('.try-btn1').html(bprice);

        if(type == 'subs') {
            $('input[data-name="Subscribe and Save"]').prop('checked', true).trigger('change').trigger('click');
            $('[data-loop-widget-selling-plan-group]').trigger('click');
            console.log('clicked');
        }
        else {
            $('input[data-name="loop-one-time-purchase"]').prop('checked', true).trigger('change').trigger('click');
            $('[data-loop-widget-onetime-purchase-option]').trigger('click');
        }
    });

    $('.try-btn1').on('click', function(e){
      e.preventDefault();
      var type = $('li.option.active').attr('data-type');
    //  $('.product-form__cart-submit, .product-form__submit').trigger('click');
    //  $(this).html("<img src='https://cdn.shopify.com/s/files/1/1744/6609/files/loading-7528_128.gif?v=1767078536' class='loading-product' alt='loading'>");

      if(type == 'subs') {
          //  addItemToCartSubscription();
        }
        else {
          //  addItemToCart();
        }
    });
});